import { render, staticRenderFns } from "./StaticReviewInfo.vue?vue&type=template&id=35fa5e64&"
import script from "./StaticReviewInfo.vue?vue&type=script&lang=js&"
export * from "./StaticReviewInfo.vue?vue&type=script&lang=js&"
import style0 from "./StaticReviewInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports